module.exports = "<p>\n  aside-nav works!\n</p>\n"